<div class="session-supplier-table-container">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>

  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-theme-alpine"
    rowSelection="multiple"
    rowHeight="48"
    rowMultiSelectWithClick="false"
    headerHeight="40"
    suppressRowClickSelection="true"
    suppressDragLeaveHidesColumns="true"
    suppressMenuHide="true"
    detailRowAutoHeight="true"
    enableCellTextSelection="true"
    suppressContextMenu="true"
    suppressHorizontalScroll="false"
    [columnDefs]="columnDefs"
    [tooltipShowDelay]="500"
    [defaultColDef]="defaultColDef"
    [paginationPageSize]="paginationPageSize"
    [pagination]="true"
    [suppressPaginationPanel]="true"
    [suppressCellSelection]="true"
    [rowData]="rowData"
    [domLayout]="domLayout"
    [groupDefaultExpanded]="false"
    [icons]="customIcons"
    [masterDetail]="true"
    [detailCellRendererParams]="detailCellRendererParams"
    [getMainMenuItems]="getSessionSupplierMainMenuItems"
    [getRowId]="getSessionSupplierRowId"
    (columnMoved)="onColumnMoved($event)"
    (columnResized)="onColumnResized($event)"
    (columnVisible)="onColumnVisible($event)"
    (rowSelected)="onSessionRowSelected($event)"
    (sortChanged)="onSortChange($event)"
    (gridReady)="onGridReady($event)"></ag-grid-angular>

  <div class="d-flex justify-content-between align-items-center mt-15 my-15 has-pagination">
    <div class="pagination-left">
      @if (totalRowsCount > paginationPageSize) {
        <app-pagination
          [totalItems]="totalRowsCount"
          [(currentPage)]="currentPageNumber"
          (change)="onPageChange($event)"
          [pageSize]="paginationPageSize"></app-pagination>
      }
    </div>
    <div class="d-flex align-items-center justify-content-end pagination-right">
      <span class="pagination-count">Showing {{ rowData?.length }} of {{ totalRowsCount }} results</span>
      <ul *ngIf="sizes.length" class="pagination">
        <li *ngFor="let size of sizes" [ngClass]="{ active: size === paginationPageSize }">
          <a (click)="changeSize($event, size)">{{ size }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #errorModalTpl let-dialogRef="dialogRef" class="big-modal">
  @if (errorDetails()) {
    <div class="modal-header mb-10">
      <div class="modal-title">
        <div>
          <h3 class="d-inline-block">
            <span class="flow-stage-label">{{ errorDetails()!.flowStage || 'Session' }}</span> error
          </h3>
          <p class="host-ip-label">{{ errorDetails()!.hostIp }}</p>
        </div>

        <button type="button" class="btn-close" (click)="dialogRef.close(true)">
          <span class="icon-close"></span>
        </button>
      </div>
    </div>
    <div class="modal-body d-flex flex-column gap-15 pos-relative">
      <div class="error-banner d-flex gap-0_5 align-items-start">
        <span class="icon-attention text-error-r2 mt-0_2"></span>

        <div>
          <h5 class="title mb-0">{{ errorDetails()!.shortText }}</h5>

          @if (errorDetails()!.description && errorDetails().errorKey !== 'SMPP_BIND_INVALID_CREDENTIALS') {
            <p class="mb-0 mt-0_5">{{ errorDetails()!.description }}</p>
          }
        </div>
      </div>

      @if (errorDetails().isAutoRetrying) {
        <div class="warning-banner d-flex gap-0_5 align-items-start">
          <span class="icon-wait spin text-warning-w2 mt-0_2"></span>

          <h5 class="title mb-0">
            {{ errorDetails()!.failedTimes + 1 }} failed attempts — <span class="font-normal">automatically retrying...</span>
          </h5>
        </div>
      }

      <div>
        <h4 class="error-details-title">Error details</h4>

        <ul class="error-details-wrapper">
          <li class="error-details-item">
            <p class="error-label">Error Layer:</p>
            <p class="error-value flow-stage-label">{{ errorDetails()!.errorLayer || '-' }}</p>
          </li>
          <li class="error-details-item">
            <p class="error-label">Flow Stage:</p>
            <p
              tooltip="Stages: Session -> Connection -> Bind. A session is created, the TCP connection is opened, then the SMPP bind is performed."
              tooltipPlacement="top"
              class="error-value cp flow-stage-label">
              {{ errorDetails()!.flowStage || '-' }}
            </p>
          </li>

          @if (errorDetails()!.commandStatusHex) {
            <li class="error-details-item">
              <p class="error-label">Error Code:</p>
              <p class="error-value">{{ errorDetails()!.commandStatusHex || '-' }}</p>
            </li>
          }

          <li class="error-details-item">
            <p class="error-label">Last Error At:</p>
            <p class="error-value">
              @if (errorDetails()!.lastErrorAtFormatted) {
                <span>{{ errorDetails()!.lastErrorAtFormatted }}</span>
              } @else {
                -
              }
            </p>
          </li>
          <li class="error-details-item">
            <p class="error-label">Last Error Timestamp:</p>
            <p class="error-value">
              @if (errorDetails()!.lastErrorAtFormatted) {
                <span>{{ errorDetails()!.lastErrorAt | date: "yyyy-MM-dd HH:mm:ss 'UTC'" : 'UTC' }}</span>
              } @else {
                -
              }
            </p>
          </li>

          @if (errorDetails().isReconnecting) {
            <li class="error-details-item">
              <p class="error-label">Status:</p>
              <p class="error-value">Automatically reconnecting...</p>
            </li>
          } @else {
            <li class="error-details-item">
              <p class="error-label">Failed Attempts:</p>
              <p class="error-value">{{ errorDetails()!.failedTimes + 1 }}</p>
            </li>
          }
        </ul>
      </div>

      <div>
        <h4 class="error-details-title">Troubleshooting</h4>

        <div class="info-banner d-flex gap-0_5 align-items-start">
          <span class="icon-info-1 mt-0_2"></span>

          <div>
            <p class="mb-0">{{ errorDetails()!.guidance || '-' }}</p>
          </div>
        </div>
      </div>

      <div>
        <h4 class="error-details-title">Original message from server</h4>
        <pre class="raw-error-block">{{ errorDetails()!.lastError || '-' }}</pre>
      </div>
    </div>
  }
</ng-template>

<ng-template #dumpModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Download dump <span class="icon-help-1 ml-15"></span></h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [hidden]="!dumpSpinner" class="spinner dump-spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    @if (conflictedSessions.length) {
      <div class="conflicted-sessions">
        <div class="alert alert-warning">
          TCP Dump for this session will also collect data from other customers' sessions listed below.<br />
          Never share the full TCP Dump with the customer in this case.
        </div>
        <div class="table-wrapper">
          <table class="table">
            <thead>
              <tr>
                <th>Session ID</th>
                <th>Enabled</th>
                <th>User</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cs of conflictedSessionsMax ? conflictedSessions : conflictedSessions.slice(0, 2)">
                <td>{{ cs.id }}</td>
                <td>{{ cs.enabled ? 'Yes' : 'No' }}</td>
                <td>{{ cs.user ? cs.user.email : cs.userId }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        @if (conflictedSessions.length > 2) {
          <div class="text-center">
            <button class="btn btn-link more-link" (click)="conflictedSessionsMax = !conflictedSessionsMax">
              {{ conflictedSessionsMax ? 'Less' : 'More' }}
            </button>
          </div>
        }

        <div class="hr-line-dashed"></div>
      </div>
    }

    @if (!dumpData.downloadUrl && dumpData.progress === '0') {
      <div class="text-center">
        <h3>Select size:</h3>
        <div class="btn-group">
          <button *ngFor="let size of dumpSizes" type="button" (click)="onClickDump(size)" class="btn btn-lg btn-primary">
            {{ size > 60 ? size / 60 : size }} {{ size > 60 ? 'min' : 'sec' }}
          </button>
        </div>
      </div>
    }

    @if (dumpData.downloadUrl) {
      <div>
        Size: <strong>{{ dumpData.fileSizeKb }} kb</strong>
        <div class="text-center mb-15">
          <div class="hr-line-dashed"></div>
          <a href="{{ dumpData.downloadUrl }}" target="_blank" class="btn btn-primary">Download</a>
        </div>
      </div>
    }

    @if (dumpData.progress !== '0' && !dumpData.downloadUrl) {
      <div>
        <h3>Capture progress</h3>
        <div class="progress">
          <div class="progress-bar progress-dump" [style.width.%]="dumpData.progress"></div>
        </div>
      </div>
    }

    @if (!dumpData.fileSize && dumpData.finish) {
      <div>
        <div class="alert alert-danger"><strong>0</strong>: packets captured</div>
      </div>
    }
  </div>
</ng-template>

<ng-template #deleteModalTpl let-dialogRef="dialogRef">
  <deletemodal [dialogRef]="dialogRef"></deletemodal>
</ng-template>
